import { useEffect, useRef } from 'react';

import { HeaderFooterEvents } from '@helsenorge/framework-utils/web-component/constants';
import type { RedirectToDetail, RedirectToUrlAfterLoginDetail } from '@helsenorge/framework-utils/web-component/events';
import useWebComponentEvents from '@helsenorge/framework-utils/web-component/useWebComponentEvents';

import { useRedirectContext } from '../redirect-provider/useRedirectContext';

interface EventSubscriberProps {
  children: React.ReactNode;
}

const EventSubscriber: React.FC<EventSubscriberProps> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { subscribe } = useWebComponentEvents<HTMLDivElement>('hn-webcomp-personvelger', ref);
  const { setRedirectToUrlAfterLogin, setRedirectTo } = useRedirectContext();

  useEffect(() => {
    const cleanup1 = subscribe(HeaderFooterEvents.setredirectto, (event: CustomEvent<RedirectToDetail>) => {
      setRedirectTo(event.detail.redirectTo);
    });
    const cleanup2 = subscribe(HeaderFooterEvents.setredirecttourlafterlogin, (event: CustomEvent<RedirectToUrlAfterLoginDetail>) => {
      setRedirectToUrlAfterLogin(event.detail.redirectToUrlAfterLogin);
    });

    return () => {
      cleanup1();
      cleanup2();
    };
  }, []);

  return <div ref={ref}>{children}</div>;
};

export default EventSubscriber;
